// @flow
import * as React from 'react';
import { LayoutActions } from 'material-ui-layout';

export default function useLayoutActionsContext() {
  return React.useContext(LayoutActions);
}
